import { Route } from 'utils/paths';

const endpoints = {
  LOG_IN: new Route('/oauth/token'),
  LOG_OUT: new Route('/oauth/revoke'),
} as const;

export default endpoints;
